module.exports = __webpack_public_path__ + "img/07.959ad769.png";